import React from "react";

const packages = [
  {
    value: "standart",
    title: "STANDART",
    price: "100€ + топливо",
    features: [
      "Исследование узлов и агрегатов",
      "Компьютерная диагностика всех систем",
      "Считывание параметров в реальном времени",
      "Фото/видео отчёт (до 50 материалов)",
      "Замер ЛКП в т.ч. поиск умной шпатлевки",
      "Визуализация ЛКП (PDF)",
      "Тест-драйв",
      "Отчёт на фирменном бланке с оценкой ТС (PDF)",
    ],
    description: "Подходит тем, кто сам нашёл авто, но хочет стандартную проверку перед покупкой.",
  },
  {
    value: "profi",
    title: "PROFI",
    price: "200€ + топливо",
    features: [
      "Всё из предыдущего пакета",
      "Эндоскопия технологичных отверстий",
      "Замер плотности жидкостей ареометром",
      "Тест АКБ",
      "Тест системы ОЖ на присутствие CO2",
      "Отчёт CarVertical",
    ],
    description: "Выбор большинства. Глубокая проверка с документальным подтверждением и реальными цифрами.",
  },
  {
    value: "premium",
    title: "PREMIUM",
    price: "500€ + топливо",
    features: [
      "Всё из предыдущих пакетов",
      "Выкуп или задаток на авто",
      "Торг с продавцом",
      "Сделка под ключ",
      "Подготовка к экспорту или регистрации в EC",
      "Транзитные номера",
    ],
    description: "Для тех, кто хочет доверить проверку и оформление под ключ.",
  },
  {
    value: "vip",
    title: "VIP «ALL IN»",
    price: "от 1500€",
    features: [
      "Всё из предыдущих пакетов",
      "Поиск авто «до победного»",
      "Доставка в Украину/ЕС",
      "Импорт/экспорт оформление",
      "Сертификация",
      "ТО, детейлинг — по договорённости",
    ],
    description: "Максимальный комфорт: ты просто забираешь готовую машину, всё остальное делаем мы.",
  },
];

export default function PricingPackages({ scrollToForm }) {
  return (
    <section id="packages" style={{ padding: "120px 20px", textAlign: "center" }}>
      <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Наши пакеты услуг</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          maxWidth: "1300px",
          margin: "0 auto",
        }}
      >
        {packages.map((pkg, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#121212",
              borderRadius: "16px",
              padding: "30px",
              width: "220px",
              boxShadow: "0 0 10px rgba(255, 255, 255, 0.05)",
              textAlign: "left",
              color: "#ccc",
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "440px",
            }}
          >
            <h3 style={{ fontSize: "24px", marginBottom: "10px", color: "#facc15" }}>{pkg.title}</h3>
            <p style={{ fontWeight: "bold", color: "#fff", marginBottom: "15px" }}>{pkg.price}</p>
            <ul style={{ paddingLeft: "20px", fontSize: "15px", marginBottom: "10px" }}>
              {pkg.features.map((f, i) => (
                <li key={i}>• {f}</li>
              ))}
            </ul>
            <p style={{ fontStyle: "italic", marginBottom: "20px" }}>{pkg.description}</p>
            <button
              onClick={() => scrollToForm(pkg.value)}
              style={{
                backgroundColor: "#facc15",
                color: "#000",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "bold",
                cursor: "pointer",
                width: "80%",
                alignSelf: "center",
                marginTop: "auto",
              }}
            >
              Оставить заявку
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
